module.exports = "<div class=\"container admin-tool\"><div class=header><h1>Hotel Admin Tool</h1><div class=admin-icon></div></div><div class=admin-tool-container><div kt-admin-navigation></div><ui-view></ui-view></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/admin.html
// module id = 593
// module chunks = 0